import './styles/index.scss';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Logic } from './logic/logic';
import SplashLoading from './components/SplashLoading/SplashLoading';
import { BrowserRouter } from 'react-router-dom';
import { StrictMode } from 'react';
import './i18n';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(<SplashLoading />);

const logic = new Logic();

function AppWithCallbackAfterRender() {
    return (
        <StrictMode>
            <BrowserRouter>
                <App logic={logic} />
            </BrowserRouter>
        </StrictMode>
    );
}

root.render(<AppWithCallbackAfterRender />);
